import CONFIG from "config/config";

// Utils
import moment from "moment";

// Common
import {
  HeaderPatientDetailWide,
  BaseHeaderDetail,
} from "react-lib/apps/HISV3/common/HeaderPdfFormTemplate";

const FORM_NAME = "FormSurgicalCountPacking";

const COLORS = {
  dark_grey: "#746A6A",
  light_grey: "#D9D9D9",
};

type FormSurgicalCountPackingProps = {
  detail: BaseHeaderDetail & {
    address?: string;
    citizen_no?: string;
    citizen_passport?: string;
    doctor_number?: string;
    patient_citizen_no?: string;
    started: string;
    patientNameTH?: string;
    patientNameEN?: string;
    adrText?: string;
  };
  operating?: any;
  operatingDetail?: any;
  surgeonName?: string;
};

const FormSurgicalCountPacking = async (props: FormSurgicalCountPackingProps) => {
  const rowTable1Empty = Array.from({ length: 11 }).map((item: any, index: number) => [
    {
      text: " ",
      style: "fieldHeaderValue",
    },
    {
      text: " ",
      style: "fieldHeaderValue",
    },
    {
      text: " ",
      style: "fieldHeaderValue",
    },
    {
      text: " ",
      style: "fieldHeaderValue",
    },
    {
      text: " ",
      style: "fieldHeaderValue",
    },
    {
      text: " ",
      style: "fieldHeaderValue",
    },
    {
      text: " ",
      style: "fieldHeaderValue",
    },
    {
      text: " ",
      style: "fieldHeaderValue",
    },
    {
      text: " ",
      style: "fieldHeaderValue",
    },
  ]);

  const rowTable2Empty = Array.from({ length: 3 }).map((item: any, index: number) => [
    {
      text: " ",
      style: "fieldHeaderValue",
    },
    {
      text: " ",
      style: "fieldHeaderValue",
    },
    {
      text: " ",
      style: "fieldHeaderValue",
    },
    {
      text: " ",
      style: "fieldHeaderValue",
    },
    {
      text: " ",
      style: "fieldHeaderValue",
    },
    {
      text: " ",
      style: "fieldHeaderValue",
    },
    {
      text: " ",
      style: "fieldHeaderValue",
    },
    {
      text: " ",
      style: "fieldHeaderValue",
    },
  ]);

  const headerForm = await HeaderPatientDetailWide({
    form: FORM_NAME,
    font: "THSarabunNew",
    logoHeight: CONFIG.COMPANY === "MSK" ? 50 : 30,
    formName: "Surgical Count & Packing",
    detail: { ...props.detail, divisionName: "Operation Room/ANES" },
    pageMargins: [0, 85, 0, 15],
    headerMargins: [7, 8, 8, 15],
    styles: {
      fieldHead: {
        bold: true,
        fontSize: 20,
      },
      fieldOPHead: {
        bold: true,
        fontSize: 16,
      },
      fieldTable: {
        bold: true,
        fontSize: 16,
      },
      fieldTableData: {
        fontSize: 16,
      },
      fieldPrintDate: {
        fontSize: 16,
      },
      tableHeader: {
        fillColor: "white",
      },
      tableNormal: {
        margin: [0, 5, 0, 5],
      },
      tableExample: {
        margin: [0, 0, 0, 0],
      },
    },
  });

  const { font, images, styles } = headerForm;

  return {
    defaultStyle: {
      font: font,
    },
    pageSize: "A4",
    pageOrientation: "landscape",
    ...headerForm,
    images: {
      ...images,
    },
    styles: {
      ...styles,
      fieldHeaderUnderline: { bold: true, fontSize: 16, margin: [0, 0, 0, -8], lineHeight: 1 },
      fieldUnderline: {
        alignment: "center",
        fontSize: 15,
        margin: [0, 0, 0, -8],
        lineHeight: 1,
      },
    },

    content: [
      {
        margin: [7, 0, 8, 0],
        table: {
          headerRows: 1,
          widths: ["auto", 90, "auto", 50, "auto", 50, "auto", 90, "auto", "*"],
          body: [
            [
              {
                text: "Operating date",
                style: "fieldHeaderUnderline",
                border: [false, false, false, false],
              },
              {
                text: " ",
                style: "fieldUnderline",
                border: [false, false, false, true],
              },
              {
                text: "start",
                style: "fieldHeaderUnderline",
                border: [false, false, false, false],
              },
              {
                text: " ",
                style: "fieldUnderline",
                border: [false, false, false, true],
              },
              {
                text: "end",
                style: "fieldHeaderUnderline",
                border: [false, false, false, false],
              },
              {
                text: " ",
                style: "fieldUnderline",
                border: [false, false, false, true],
              },
              {
                text: "OR Room",
                style: "fieldHeaderUnderline",
                border: [false, false, false, false],
              },
              {
                text: " ",
                style: "fieldUnderline",
                border: [false, false, false, true],
              },
              {
                text: "Operation",
                style: "fieldHeaderUnderline",
                border: [false, false, false, false],
              },
              {
                text: " ",
                style: "fieldUnderline",
                border: [false, false, false, true],
              },
            ],
          ],
        },
        layout: {
          hLineStyle: function (i: number, _node: any) {
            return { dash: { length: 1, space: 1.5 } };
          },
          hLineWidth: function (i: number, _node: any) {
            return 0.5;
          },
        },
      },
      {
        margin: [7, 5, 8, 0],
        table: {
          headerRows: 1,
          widths: ["auto", 300, "auto", "*"],
          body: [
            [
              {
                text: "Surgeon",
                style: "fieldHeaderUnderline",
                border: [false, false, false, false],
              },
              {
                text: " ",
                style: "fieldUnderline",
                border: [false, false, false, true],
              },
              {
                text: "Anesthesiologist",
                style: "fieldHeaderUnderline",
                border: [false, false, false, false],
              },
              {
                text: " ",
                style: "fieldUnderline",
                border: [false, false, false, true],
              },
            ],
          ],
        },
        layout: {
          hLineStyle: function (i: number, _node: any) {
            return { dash: { length: 1, space: 1.5 } };
          },
          hLineWidth: function (i: number, _node: any) {
            return 0.5;
          },
        },
      },
      {
        margin: [7, 10, 8, 0],
        table: {
          headerRows: 1,
          widths: ["*", 70, 70, 70, 50, 70, 70, 50, "*"],
          body: [
            [
              {
                text: "Item",
                margin: [0, 10, 0, 0],
                style: "fieldHeader",
                fillColor: COLORS.light_grey,
              },
              {
                text: "Pre-Op",
                margin: [0, 10, 0, 0],
                style: "fieldHeader",
                fillColor: COLORS.light_grey,
              },
              {
                text: `Start\nclosure`,
                style: "fieldHeader",
                fillColor: COLORS.light_grey,
              },
              {
                text: `Final\nclosure`,
                style: "fieldHeader",
                fillColor: COLORS.light_grey,
              },
              {
                text: "Total",
                margin: [0, 10, 0, 0],
                style: "fieldHeader",
                fillColor: COLORS.light_grey,
              },
              {
                text: "Scrub",
                margin: [0, 10, 0, 0],
                style: "fieldHeader",
                fillColor: COLORS.light_grey,
              },
              {
                text: "Circulating",
                margin: [0, 10, 0, 0],
                style: "fieldHeader",
                fillColor: COLORS.light_grey,
              },
              {
                text: "Total",
                margin: [0, 10, 0, 0],
                style: "fieldHeader",
                fillColor: COLORS.light_grey,
              },
              {
                text: "Remark",
                margin: [0, 10, 0, 0],
                style: "fieldHeader",
                fillColor: COLORS.light_grey,
              },
            ],
            ...rowTable1Empty,
          ],
        },
        layout: {
          hLineColor: function (i: string, node: any) {
            return COLORS.dark_grey;
          },
          vLineColor: function (i: string, node: any) {
            return COLORS.dark_grey;
          },
        },
      },
      {
        margin: [7, 5, 8, 0],
        table: {
          headerRows: 1,
          widths: ["*", 50, "*", 80, "*", "*", 70, 60],
          body: [
            [
              {
                text: "Shift Handover",
                style: "fieldHeader",
                fillColor: COLORS.light_grey,
              },
              {
                text: "Time",
                style: "fieldHeader",
                fillColor: COLORS.light_grey,
              },
              {
                text: "Scrub (Previous shift)",
                style: "fieldHeader",
                fillColor: COLORS.light_grey,
              },
              {
                text: "Scrub (New shift)",
                style: "fieldHeader",
                fillColor: COLORS.light_grey,
              },
              {
                text: "Circulating (Previous shift)",
                style: "fieldHeader",
                fillColor: COLORS.light_grey,
              },
              {
                text: "Circulating (New shift)",
                style: "fieldHeader",
                fillColor: COLORS.light_grey,
              },
              {
                text: "Count Verified",
                style: "fieldHeader",
                fillColor: COLORS.light_grey,
              },
              {
                text: "Remark",
                style: "fieldHeader",
                fillColor: COLORS.light_grey,
              },
            ],
            ...rowTable2Empty,
          ],
        },
        layout: {
          hLineColor: function (i: string, node: any) {
            return COLORS.dark_grey;
          },
          vLineColor: function (i: string, node: any) {
            return COLORS.dark_grey;
          },
        },
      },
      {
        margin: [7, 5, 8, 0],
        table: {
          headerRows: 1,
          widths: ["auto", "*"],
          body: [
            [
              {
                text: "Remaining Packing Item(s): ",
                style: "fieldHeaderUnderline",
                border: [false, false, false, false],
              },
              {
                text: " ",
                style: "fieldHeaderUnderline",
                border: [false, false, false, true],
              },
            ],
          ],
        },
        layout: {
          hLineStyle: function (i: number, _node: any) {
            return { dash: { length: 1, space: 1.5 } };
          },
          hLineWidth: function (i: number, _node: any) {
            return 0.5;
          },
        },
      },
      {
        margin: [7, 5, 8, 0],
        table: {
          headerRows: 1,
          widths: ["*", "auto", 200],
          body: [
            [
              {
                text: " ",
                style: "fieldHeaderUnderline",
                border: [false, false, false, true],
              },
              {
                text: "Date planned for removal: ",
                style: "fieldHeaderUnderline",
                border: [false, false, false, false],
              },
              {
                text: " ",
                style: "fieldHeaderUnderline",
                border: [false, false, false, true],
              },
            ],
          ],
        },
        layout: {
          hLineStyle: function (i: number, _node: any) {
            return { dash: { length: 1, space: 1.5 } };
          },
          hLineWidth: function (i: number, _node: any) {
            return 0.5;
          },
        },
      },
    ],
  };
};

export default FormSurgicalCountPacking;
